import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Box, Typography, Grid } from '@mui/material';
import Container from './Container';
import { useCombinedContext } from '../AnimationContext';

const WidgetContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
}));

const WidgetItem = styled(motion.div)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  textAlign: 'center',
  height: '100%',
}));

interface WidgetData {
  title: string;
  value: string;
  color: string;
}

const initialWidgets: WidgetData[] = [
  { title: 'User Count', value: '1,234', color: '#4caf50' },
  { title: 'Revenue', value: '$5,678', color: '#2196f3' },
  { title: 'Orders', value: '90', color: '#ff9800' },
  { title: 'Visitors', value: '8,901', color: '#e91e63' },  { title: 'User Count', value: '1,234', color: '#4caf50' },
  { title: 'Revenue', value: '$5,678', color: '#2196f3' },
  { title: 'Orders', value: '90', color: '#ff9800' },
  { title: 'Visitors', value: '8,901', color: '#e91e63' },  { title: 'User Count', value: '1,234', color: '#4caf50' },
  { title: 'Revenue', value: '$5,678', color: '#2196f3' },
  { title: 'Orders', value: '90', color: '#ff9800' },
  { title: 'Visitors', value: '8,901', color: '#e91e63' },
];

const Widget: React.FC = () => {
  const [widgets, setWidgets] = useState<WidgetData[]>([]);
  const { settings } = useCombinedContext();

  useEffect(() => {
    // Simulate a delay in loading data
    setTimeout(() => {
      setWidgets(initialWidgets);
    }, 500);
  }, []);

  useEffect(() => {
    // Rearrange widgets every 5 seconds
    const interval = setInterval(() => {
      setWidgets(prevWidgets => {
        const newWidgets = [...prevWidgets];
        for (let i = newWidgets.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [newWidgets[i], newWidgets[j]] = [newWidgets[j], newWidgets[i]];
        }
        return newWidgets;
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div {...settings}>
      <WidgetContainer>
        <Container title="Widgets Overview">
          <Grid container spacing={3}>
            <AnimatePresence>
              {widgets.map((widget, index) => (
                <Grid item xs={12} sm={6} md={3} key={widget.title}>
                  <WidgetItem
                    layout
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.5 }}
                    transition={{
                      opacity: { duration: 0.2 },
                      scale: { duration: 0.5 },
                      layout: { duration: 0.5 }
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      {widget.title}
                    </Typography>
                    <Typography variant="h4" style={{ color: widget.color }}>
                      {widget.value}
                    </Typography>
                  </WidgetItem>
                </Grid>
              ))}
            </AnimatePresence>
          </Grid>
        </Container>
      </WidgetContainer>
    </motion.div>
  );
};

export default Widget;